import CloseIcon from "~/assets/icons/close.svg";
import { IoIosCloseCircle } from "react-icons/io";
import React, {type Dispatch, type SetStateAction} from "react";

export default function ErrorFormCard({setErrorAction, editationMode}: {setErrorAction: Dispatch<SetStateAction<boolean | null>>, editationMode?: boolean}) {
  return (
    <>
      <div className="relative mb-10 flex w-full flex-col items-center gap-5 rounded-[36px] bg-[#FF6D0014] p-16">
        <div
          onClick={() => setErrorAction(false)}
          className="ripple absolute right-0 top-1 z-50 flex cursor-pointer flex-col items-center rounded-full p-4 text-sm text-warning-primary transition-all duration-300 ease-linear hover:bg-[#FF6D0014] active:bg-[#FF6D0014] lg:right-4"
        >
          <CloseIcon />
        </div>
        <span className="h1 text-warning-primary">
          <IoIosCloseCircle />
        </span>
        <h2 className="h3 mx-auto text-warning-primary">Neúspěšné přidání</h2>
        <p>
          Zprávu se nepodařilo {editationMode ? "upravit" :"přidat"}. Zkontrolujte prosím připojení k internetu
          a pokus opakujte
        </p>
      </div>
    </>
  );
}
